import { Component } from '@angular/core';

@Component({
	selector: 'cv-loader',
	templateUrl: 'loader.component.html',
	styleUrls: ['loader.component.scss']
})
export class LoaderComponent {

}
